import { render, staticRenderFns } from "./CustomCalendar.vue?vue&type=template&id=375a8080&"
import script from "./CustomCalendar.vue?vue&type=script&lang=js&"
export * from "./CustomCalendar.vue?vue&type=script&lang=js&"
import style0 from "./CustomCalendar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports